/* global BigInt */
// Payment arithmetic only: API and database amounts remain decimal Numbers.
// Keep this policy identical in mose-server/services/payments/money.js and
// mose-web/src/utils/paymentMoney.mjs. Round decimal halves away from zero.
export function toCents(amount) {
    if (typeof amount !== 'number' || !Number.isFinite(amount)) {
        throw new Error('Payment amount must be a finite number.');
    }
    const negative = amount < 0;
    const [coefficient, exponentText = '0'] = Math.abs(amount).toString().toLowerCase().split('e');
    const [whole, fraction = ''] = coefficient.split('.');
    const digits = BigInt(whole + fraction);
    const shift = Number(exponentText) - fraction.length + 2;
    let value;
    if (shift >= 0) {
        value = digits * (10n ** BigInt(shift));
    } else {
        const divisor = 10n ** BigInt(-shift);
        value = digits / divisor + ((digits % divisor) * 2n >= divisor ? 1n : 0n);
    }
    if (value > BigInt(Number.MAX_SAFE_INTEGER)) {
        throw new Error('Payment amount exceeds the supported cent range.');
    }
    return value === 0n ? 0 : Number(negative ? -value : value);
}

export function addCents(left, right) {
    const result = left + right;
    if (![left, right, result].every(Number.isSafeInteger)) {
        throw new Error('Payment total exceeds the supported cent range.');
    }
    return result;
}

export function fromCents(value) {
    if (!Number.isSafeInteger(value)) throw new Error('Invalid integer-cent amount.');
    const amount = value === 0 ? 0 : value / 100;
    if (toCents(amount) !== value) throw new Error('Payment amount cannot be represented safely.');
    return amount;
}
